import { createContext, createElement, useContext, type ReactNode } from 'react'

export interface OnboardingChrome {
  tourActive: boolean
  setTourActive: (active: boolean) => void
  openAccountMenu: () => void
  closeAccountMenu: () => void
  openCreateMenu: () => void
  closeCreateMenu: () => void
  registerSearchOpener: (open: () => void) => () => void
  openSearch: () => void
}

const OnboardingChromeContext = createContext<OnboardingChrome | null>(null)

export function OnboardingChromeProvider({
  value,
  children,
}: {
  value: OnboardingChrome
  children: ReactNode
}) {
  return createElement(OnboardingChromeContext.Provider, { value }, children)
}

export function useOnboardingChrome() {
  return useContext(OnboardingChromeContext)
}
